import { getCookie, setCookie, delete_cookie } from "./cookieManager";

const AUTH_TOKEN_KEY = 'profile_token';

class AuthService {
    getAuthToken(): string|null {
        return getCookie(AUTH_TOKEN_KEY) || null;
    }
    setAuthToken(token: string) {
        setCookie(AUTH_TOKEN_KEY, token);
    }
    clearAuthToken() {
        delete_cookie(AUTH_TOKEN_KEY);
    }
    getAuthHeader() {
        return {
            "Authorization": `Bearer ${this.getAuthToken()}`
        }
    }
}

export default new AuthService();